<template>
  <div style="width:100%;height:auto; margin:5px 0 auto auto;">
    <el-form>
      <!-- 
      <el-row :gutter="20">
        <el-col :span="16" v-if="visable === '1'">
          <el-button type="primary" @click="drawRectangle">绘制多边形</el-button>
          <el-button type="primary" @click="deleRectangle">删除多边形</el-button>
          <el-button v-if="false" type="primary" @click="drawLine">绘制折线</el-button>
          <el-button v-if="false" type="primary" @click="startAnimation">开始回放</el-button>
        </el-col>
      </el-row>
       -->
      <el-row :gutter="20" style="margin-top:5px">
        <el-col :span="24">
        <div id="amapcontainerRouter"  :style="{width: divWidth, height: divHeight}"></div>
        </el-col>
      </el-row>
    </el-form>
    <el-drawer :visible.sync="menuViewVisible" :close-on-click-modal="false" append-to-body :title="title" size="70%">
      <menu-view v-if="menuViewVisible" ref="menuView" :proid="code" :visible.sync="menuViewVisible" />
    </el-drawer>
  </div>
</template>
 
<script>
import { getLocationCurrent as getInfo } from '@/api/epvVehicle'
import truck from '../../../public/imgs/truck1.svg'
import menuView from '../../views/operational/mapRouter/view'
import bus from '@/eventBus/eventBus.js';
import AMapLoader from '@amap/amap-jsapi-loader';
window._AMapSecurityConfig = {
  securityJsCode: process.env.VUE_APP_AMAP_SECURITYCODE
}
export default { // pagekey
  components: { menuView },
  props: {
    proid: { // 车牌号
      type: String,
      required: false
    },
    visable: {
      type: String,
      required: true
    },
    pagekey: {
      type: String,
      required: false
    },
    paths: {} // 编辑
  },
  data () {
    return {
      truck: {},
      menuViewVisible: false,
      zoom: 11,
      truckSvg: truck,
      divWidth: '100%',
      divHeight: '800px',
      map: null,
      marker: null,
      autoOptions: {
        input: ''
      },
      form:{
        province:'',//省
        city:'',//市
        district:''//区
      },
      placeSearch: null,
      searchPlaceInput: '',
      auto: null,
      geoCoder:null,
      // 绘制多边形
      path: [], // 当前绘制的多边形经纬度数组
      polygonItem: [], // 地图上绘制的所有多边形对象
      polyEditors: [],  // 所有编辑对象数组
      lineArr: [], // 动画组
      lineArrAll: [],
      points:[], // 当前车辆
      title: ''
    }
  },
  created() {
    // 初始化定义自定义窗体里面的方法
    // window.handleRouterBack =()=>{
    //   this.routerBack()
    // }
    this.formMapSize()
    bus.$on('inputObject', val => {
      this.autoOptions.input = val.search_id
      this.searchPlaceInput = val.input
    })
  },
  methods: {
    // 获取明细数据
    getDetailed() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      getInfo({ carName: this.proid }).then(response => {
        this.points = []
        this.truck = response.data
        loading.close()
        this.points.push(this.truck)
        if (this.points.length>0) {
          this.initMarker()
        }
      }).catch(function() {
        loading.close()
      })
    },
    // 查看电子围栏
    handleRouterBack() {
      this.title = '轨迹回放 | 车牌: '+ this.truck.plateNumber
      this.menuViewVisible = true
      this.code = this.truck.plateNumber
      this.$nextTick(() => {
        this.$refs.menuViewVisible
        // this.$refs.menuView.getDetailed()
      })
    },
    formMapSize(){
      if (this.visable !== '1') {
        this.divHeight = '750px'
      }
    },
    initAMap (callBack) {
      AMapLoader.load({
        key: process.env.VUE_APP_AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale", "AMap.ToolBar", "AMap.ControlBar", 'AMap.Geocoder', 'AMap.Marker',
          'AMap.CitySearch', 'AMap.Geolocation', 'AMap.AutoComplete', 'AMap.InfoWindow','AMap.mouseTool','AMap.PlaceSearch,AMap.MoveAnimation'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((RAMap) => {
        this.RAMap = RAMap
        this.RAMap.plugin(['AMap.MouseTool', 'AMap.PolyEditor', 'AMap.ControlBar'], function () {
        //TODO  创建控件并添加
        });
        // 获取到作为地图容器的DOM元素，创建地图实例
        this.map = new RAMap.Map("amapcontainerRouter", { //设置地图容器id
          resizeEnable: true,
          // zoom: this.zoom, // 地图显示的缩放级别
          viewMode: "3D", // 使用3D视图
          zoomEnable: true, // 地图是否可缩放，默认值为true
          dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
          doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图，默认为true
          zoom: this.zoom, //初始化地图级别
          center: [113.300129, 40.076762], // 初始化中心点坐标 大同市
          // mapStyle: "amap://styles/darkblue", // 设置颜色底层
        })
        this.map.addControl(new RAMap.ControlBar());
        this.mouseTool = new this.RAMap.MouseTool(this.map);
        if (callBack && typeof callBack == 'function') {
          callBack();
        }

      }).catch(e => {
          console.log(e)
        })
    },
    initMarker() {
      var markerList = [];
      this.points.forEach(point => {
        // 创建一个 Marker 实例：
        var marker = new this.RAMap.Marker({
          position: new this.RAMap.LngLat(point.lng, point.lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          icon: this.truckSvg, //显示的图标
        });
        //给标记点添加点击事件
        marker.on("click", e => {//给每一个点位增加点击事件
          this.initInfoWindow(point);
          this.infoWindow.open(this.map, marker.getPosition());
        });
        markerList.push(marker)
      })
      this.map.add(markerList);
      // 缩放地图到合适的视野级别
      this.map.setFitView();
    },
    //构建自定义信息窗体
    createInfoWindow(title, content) {
      var info = document.createElement("div");
      info.className = "custom-info input-card content-window-card";
      //可以通过下面的方式修改自定义窗体的宽高
      info.style.width = "400px";
      // 定义顶部标题
      var top = document.createElement("div");
      var titleD = document.createElement("div");
      var closeX = document.createElement("img");
      top.className = "info-top";
      titleD.innerHTML = title;
      closeX.src = require("@/assets/images/close.gif")
      closeX.onclick = this.closeInfoWindow;

      top.appendChild(titleD);
      top.appendChild(closeX);
      info.appendChild(top);

      // 定义中部内容
      var middle = document.createElement("div");
      middle.className = "info-middle";
      middle.style.backgroundColor = 'white';
      middle.innerHTML = content;
      info.appendChild(middle);
      // 定义底部内容
      var bottom = document.createElement("div");
      bottom.className = "info-bottom";
      bottom.style.position = 'relative';
      bottom.style.top = '0px';
      bottom.style.margin = '0 auto';
      info.appendChild(bottom);
      return info;
    },
    //关闭信息窗体
    closeInfoWindow() {
      this.map.clearInfoWindow();
    },
    initInfoWindow(e) {
      //实例化信息窗体
      var title ='车辆详情';
      var status =''
      if (e.status === '2') {
        status += '<span style="color:#F00;">离线</span>';
      } else {
        status += '<span style="color:#0F0;">在线</span>';
      }
      var content = [];
      if (!e.loadTypeName) {
        e.loadTypeName = ''
      }

       var data = '<table border="0" style="margin:10px 10px 10px 20px">' +
'<tr> <td>车辆牌照</td> <td style="text-align:right;padding-right: 10px;">'+e.plateNumber+'</td> <td>车牌颜色</td> <td style="text-align:right">'+e.colorTypeName+'</td> </tr>' +
'<tr> <td>车辆状态</td> <td style="text-align:right;padding-right: 10px;">'+status+'</td> <td>动力类型</td> <td style="text-align:right">'+e.fuelTypeName+'</td> </tr>' +
'<tr> <td>车辆类型</td> <td style="text-align:right;padding-right: 10px;">'+e.loadTypeName+'</td> <td>里程(km)</td> <td style="text-align:right">'+e.tmnMile+'</td> </tr>' +
'<tr> <td>所属公司</td> <td style="text-align:right;padding-right: 10px;">'+e.companyName+'</td> </tr>' +
'<tr> <td>最新数据时间</td> <td style="text-align:right;padding-right: 10px;">'+e.time+'</td> </tr>' +
'</table>'

var buttonData = '<div><button  style="display:block;margin:0 auto" onclick="handleRouterBack()">轨迹回放</button></div>'


      content.push(data);
      content.push(buttonData);
      this.infoWindow = new this.RAMap.InfoWindow({
        isCustom: true,  //使用自定义窗体
        content: this.createInfoWindow(title, content.join("<br>")),
        offset: new this.RAMap.Pixel(16, -45)
      });
    },
    // routerBack(e){
    //   this.$message.info('轨迹回放==='+e)
    // }
  },
  mounted () {
    var that = this
    //DOM初始化完成进行地图初始化
    this.initAMap(() => {
      setTimeout(x=>{
        this.initMarker()
      }, 1000)
    });
    
    // 初始化定义自定义窗体里面的方法
    window.handleRouterBack =this.handleRouterBack
  },
  watch: {
    searchPlaceInput(newValue) {
      if (newValue != null) {
        this.placeSearch.search(newValue)
      }
    }
  }

}
</script>
 
<style lang="less">
  .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 50px;
        .label {
            width: 100px;
        }
    }
    .amap-sug-result {
        z-index: 9999 !important;
    }

    .content-window-card {
    position: relative;
    box-shadow: none;
    bottom: 0;
    left: 0;
    width: auto;
    padding: 0;
  }
  
  .content-window-card p {
    height: 2rem;
  }
  
  div.info-top {
    position: relative;
    background: #0f49b5;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #fff;
    padding: 0 10px;
  }
  
  div.info-top span:nth-child(2) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
  
  div.info-top img {
    position: absolute;
    top: 8px;
    right: 10px;
    transition-duration: 0.25s;
    width: 15px;
  }
  
  div.info-top img:hover {
    box-shadow: 0px 0px 5px #000;
  }
  
  div.info-middle {
    background: rgba(0,54,98,.8)!important;
    font-size: 12px;
    padding: 10px 6px;
    line-height: 20px;
    color: #fff;
  }
  
  div.info-bottom {
    height: 0px;
    width: 100%;
    clear: both;
    text-align: center;
    width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 15px solid transparent;
      border-top: 20px solid rgba(0,54,98,.8);
  }
  
  div.info-bottom img {
    position: relative;
    z-index: 104;
  }
  
  
  .info-middle img {
    float: left;
    margin-right: 6px;
  }


</style>